import {ActionIcon, Menu, MenuDropdownProps, MenuProps} from '@mantine/core'
import {Children, ReactNode} from 'react'
import {HiDotsVertical} from 'react-icons/hi'
import {StyleProps} from 'shared/ui'

export const OverflowMenu = ({
  children,
  className,
  style,
  ...menuProps
}: {children: ReactNode} & MenuProps & StyleProps) => {
  const empty = Children.toArray(children).filter(c => c).length === 0
  return (
    <Menu {...{width: 200, ...menuProps}}>
      <Menu.Target>
        <ActionIcon
          className={className}
          variant='subtle'
          style={{minWidth: '1.3rem', width: '1.3rem', visibility: empty ? 'hidden' : undefined, ...style}}>
          <HiDotsVertical size='1.3em' />
        </ActionIcon>
      </Menu.Target>
      <Menu.Dropdown>{children}</Menu.Dropdown>
    </Menu>
  )
}
